export {
  LinearGauge,
  type LinearGaugeProps,
  type LinearGaugeSegment,
} from './LinearGauge';
